module.exports = __webpack_public_path__ + "static/media/3d.19cf93ad.svg";